const BOTI_SRC = 'https://boti.bot/conversation-widget.js'

export function loadBoti() {
  if (typeof document === 'undefined') return
  if (document.querySelector('script[data-boti-token]')) return
  const script = document.createElement('script')
  script.src = BOTI_SRC
  script.async = true
  script.dataset.botiToken = '07ac1ec3'
  script.dataset.botiChannelId = '573'
  script.dataset.botiColor = '#0e1d6b'
  document.head.appendChild(script)
}
